<template>
  <v-container>
    <Heading msg="My Profile" />
    <v-card class="pa-5 mx-auto" max-width="800">
      <Profile />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Profile from "@/components/Forms/Profile.vue";
import Heading from "@/components/Layout/Heading.vue";

export default {
  name: "User",
  props: {
    userDetails: {
      type: Object,
      required: true,
    },
  },

  components: { Profile, Heading },

  data: () => ({
    // ui/ux variables
    alert: false, // alert diplay status
    alertMsg: "Failure!", // alert massage
    valid: false, // form validity
    editProfile: false, // user wants to edit the profile
    isSuccess: false, // updating profile was successful or not
    loading: false, // update btn is loading

    firstname: "", // firstname
    lastname: "", // lastname
    email: "", // email
    phone: "", // phone number

    rules: {
      // form validation rules
      required: (v) => !!v || "Required.",
      name: (v) =>
        (v && v.length >= 5) ||
        "This field must contain more than 5 characters",
      phone: (v) => (v && v.length == 10) || "Invalid phone number",
      email: (v) => (v && /.+@.+\..+/.test(v)) || "E-mail must be valid",
      password: {
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
    },
  }),

  mounted() {
    this.firstname = this.userDetails.fname || "";
    this.lastname = this.userDetails.lname || "";
    this.phone = this.userDetails.phonenumber || "";
    this.email = this.userDetails.email || "";
  },

  computed: {
    alertType() {
      // alert type error or success in this case
      return this.isSuccess ? "sokoDeep" : "error";
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),
    async updateProfile() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const data = {
          fname: this.firstname,
          lname: this.lastname,
          phonenumber: this.phone,
        };

        const response = await this.makeFetch({
          method: "patch",
          body: data,
          addUrl: "/update",
          withId: true,
          stateVar: "user",
        }).catch((err) => {
          console.log(err);
          this.alertMsg =
            "No connection was established to update your profile. Please try again later!";
          this.isSuccess = false;
          this.alert = true;
          this.loading = false;
          return;
        });

        this.isSuccess = response;

        this.alertMsg = this.isSuccess
          ? "Profile updated successfully"
          : "Could not update profile. Please try again later!";

        this.alert = true;
        this.loading = false;

        // dismiss alert after 3s
        // setTimeout(() => (this.alert = false), 10000);
      } else {
        this.alertMsg = "The form did not pass validation.";
        this.alert = true;
      }
    },
  },
};
</script>
